import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "row mb-4" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  class: "col-md-12"
}
const _hoisted_6 = { class: "p-3 d-flex justify-content-end align-items-center price-display" }
const _hoisted_7 = {
  class: "bi bi-info-circle",
  tabindex: "0",
  role: "button",
  "aria-label": "Info"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PricingStrategyNameDaysComponent = _resolveComponent("PricingStrategyNameDaysComponent")!
  const _component_UtilizationPricingSettings = _resolveComponent("UtilizationPricingSettings")!
  const _component_PriceUnitComponent = _resolveComponent("PriceUnitComponent")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.currentStrategy.isMultipleWindows)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_PricingStrategyNameDaysComponent, {
              name: _ctx.windowProp.name,
              description: _ctx.windowProp.description,
              daysIn: _ctx.windowProp.daysIn,
              daysOut: _ctx.windowProp.daysOut,
              invalidDaysIn: _ctx.invalidDaysIn(_ctx.windowProp.id),
              invalidDaysOut: _ctx.invalidDaysOut(_ctx.windowProp.id),
              daysInMoreThanDayOut: _ctx.daysInMoreThanDayOut(_ctx.windowProp.id),
              invalidName: _ctx.invalidName(_ctx.windowProp.id),
              onUpdateWindow: _ctx.handleUpdateWindowProp
            }, null, 8, ["name", "description", "daysIn", "daysOut", "invalidDaysIn", "invalidDaysOut", "daysInMoreThanDayOut", "invalidName", "onUpdateWindow"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.currentStrategy.isAdjustByUtilization)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_UtilizationPricingSettings, {
                ref: (el) => { _ctx.$emit('update:dailyUtilizationSettingsRef', el as ComponentPublicInstance | null) },
                "initial-data": _ctx.utilizationPricesByWindowId[_ctx.windowProp.id ?? 0],
                "is-all-week": true,
                "is-all-day": true,
                "price-window-id": _ctx.windowProp.id ?? 0,
                onSaveSuccess: _ctx.handlePricingSaveSuccess,
                onSaveError: _ctx.handlePricingSaveError
              }, null, 8, ["initial-data", "price-window-id", "onSaveSuccess", "onSaveError"])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.currentStrategy.isAdjustByUtilization)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _cache[2] || (_cache[2] = _createElementVNode("span", null, "Display at", -1)),
                _createVNode(_component_PriceUnitComponent, {
                  value: _ctx.getUtilizationPrice(_ctx.windowProp.id ?? 0, 0),
                  isPercent: _ctx.getUsePercent(_ctx.windowProp.id ?? 0, 0),
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (
                _ctx.updateUtilizationPrice(_ctx.windowProp.id ?? 0, 0, $event)
              )),
                  "onUpdate:isPercent": _cache[1] || (_cache[1] = ($event: any) => (
                _ctx.updateUsePercent(_ctx.windowProp.id ?? 0, 0, $event)
              ))
                }, null, 8, ["value", "isPercent"]),
                _withDirectives(_createElementVNode("i", _hoisted_7, null, 512), [
                  [_directive_tooltip, {
                content:
                  'When applying this strategy:<br>If % is selected, a booking channel\'s pricing will be shown as this percentage of the regular rate.<br>If $ is selected, this amount will be shown.',
                placement: 'top',
                triggers: ['hover', 'focus'],
                html: true,
                popperClass: 'custom-tooltip',
              }]
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}